import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { CurrencyInputDirective } from '../../../../../directives/currency-input.directive';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldModel } from '../../../../../models/extraction-models/extraction-models';
import { NgClass } from '@angular/common';
import { ExtractedValue } from '../../../../../models/extracted-values';
import { TooltipDirective } from '@vydaps/gui-commons';
import { INPUT_STYLING_SERVICE } from '../../../../../service/input-styling.service';
import { errorText } from '@ps-gui/ui';
import { RemoveWrappingCommaValueAccessor } from '../../../remove-wrapping-comma-value-accessor.directive';

@Component({
  selector: 'ct-extraction-table-item-input',
  imports: [
    CurrencyInputDirective,
    FormsModule,
    NgClass,
    TooltipDirective,
    ReactiveFormsModule,
    RemoveWrappingCommaValueAccessor,
  ],
  template: `
    @if (fieldModel().type === 'currency') {
      <input
        class="table-input box-border block h-full w-full rounded border p-1 text-left ring-1"
        [attr.data-testid]="fieldModel().key"
        ctExtractionCurrencyInput
        [ngClass]="getInputClasses()"
        (focus)="focused.emit()"
        (input)="userInput.emit()"
        [formControl]="control()"
        position="left"
        [appTooltip]="control().invalid ? errorText(control()) : ''" />
    } @else {
      <div class="relative h-[34px]">
        <div
          class="table-input box-border block w-full overflow-y-auto rounded border p-1 text-left ring-1"
          [attr.data-testid]="fieldModel().key"
          contenteditable
          ctExtractionRemoveWrappingCommaInput
          [ngClass]="getInputClasses(true)"
          (focus)="focused.emit()"
          (input)="userInput.emit()"
          [formControl]="control()"
          position="left"
          [appTooltip]="control().invalid ? errorText(control()) : ''"></div>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableItemInputComponent {
  private readonly inputStylingService = inject(INPUT_STYLING_SERVICE);

  readonly fieldModel = input.required<FieldModel>();
  readonly control = input.required<FormControl<ExtractedValue>>();
  readonly isActive = input.required<boolean>();

  focused = output();
  userInput = output();

  getInputClasses(autoGrowHeight = false) {
    const valueControl = this.control();
    return this.inputStylingService.getDefaultInputClasses(
      valueControl.value,
      this.isActive(),
      valueControl.invalid && valueControl.touched,
      autoGrowHeight,
    );
  }

  protected readonly errorText = errorText;
}
